import React from 'react';
import { useSpring, animated } from '@react-spring/web';
import backgroundImage from '../assets/images/landing_page_image2.webp';

export default function BackgroundTextSection() {
  // Define the animations
  const textAnimation = useSpring({
    from: { opacity: 0, transform: 'translateY(30px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: { tension: 200, friction: 20 },
    delay: 300,
  });

  const backdropAnimation = useSpring({
    from: { opacity: 0, backdropFilter: 'blur(0px)' },
    to: { opacity: 1, backdropFilter: 'blur(8px)' },
    config: { tension: 180, friction: 12 },
    delay: 100,
  });

  return (
    <section
      id="home"
      className="relative min-h-screen bg-cover bg-center"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div className="opacity-100 absolute top-2 right-8 sm:right-12 lg:right-16">
        <animated.div
          style={{
            ...textAnimation,
            ...backdropAnimation,
            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.90) 100%)',
            backdropFilter: 'blur(8px)',
            border: '1px solid rgba(231, 224, 221, 0.6)',
            boxShadow: '0 20px 40px -12px rgba(55, 47, 47, 0.3)',
          }}
          className="relative max-w-xs z-10 p-4 sm:p-5 rounded-xl shadow-xl"
        >
          {/* Premium badge */}
          <div className="inline-flex items-center px-2 py-1 bg-gradient-to-r from-primary to-accent text-background-primary text-xs font-semibold rounded-full mb-3 shadow-md">
            <span className="w-1 h-1 bg-background-primary rounded-full mr-1.5 animate-pulse"></span>
            Premium Quality
          </div>

          <h1 className="text-xs sm:text-sm text-text-primary font-semibold mb-2 tracking-wide">
            Premium Polybags, Crafted for Every Industry
          </h1>
          
          <h2 className="text-lg sm:text-xl font-bold mb-2 leading-tight">
            <span className="text-primary drop-shadow-sm">
              LDPE & HDPE
            </span>
            <br />
            <span className="text-accent drop-shadow-sm">
              Bags, Reels & Films
            </span>
          </h2>
          
          {/* Certification badges */}
          <div className="flex flex-wrap items-center gap-1 mb-3">
            <span className="text-xs font-medium text-text-primary">Certified</span>
            <span className="text-text-secondary text-xs">—</span>
            <div className="flex gap-1.5">
              <span className="inline-flex items-center px-1.5 py-0.5 bg-secondary text-text-primary text-xs font-bold rounded border border-primary/20">
                ISO
              </span>
              <span className="inline-flex items-center px-1.5 py-0.5 bg-secondary text-text-primary text-xs font-bold rounded border border-primary/20">
                HALAL
              </span>
              <span className="inline-flex items-center px-1.5 py-0.5 bg-secondary text-text-primary text-xs font-bold rounded border border-primary/20">
                GRS
              </span>
              <span className="inline-flex items-center px-1.5 py-0.5 bg-secondary text-text-primary text-xs font-bold rounded border border-primary/20">Food Safe</span>
            </div>
          </div>

          {/* Call to action */}
          {/* <button className="w-full px-3 py-2 bg-accent hover:bg-accent/90 text-background-primary font-semibold rounded-lg shadow-md transform hover:scale-105 transition-all duration-200 text-xs">
            Get Your Quote Today
          </button> */}
        </animated.div>
      </div>
    </section>
  );
}